import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { setSession } from '../services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class TokenGuard implements CanActivate {

  constructor(private location: Location) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const token = next.queryParamMap.get('token');
    const refreshToken = next.queryParamMap.get('refreshToken');
    if (token && refreshToken) {
      setSession({ token, refreshToken });
      const cleanUrl = state.url.split('?')[0];
      this.location.replaceState(cleanUrl);
    }

    return true;
  }
}
